export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14727.0f031cd6.jpg";